// src/modules/pos/components/CartBasket.tsx
import React from "react";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Badge from "@mui/material/Badge";

type CartIconProps = {
  cart: { quantity: number }[];
  onClick?: () => void;
};

const CartBasket: React.FC<CartIconProps> = ({ cart, onClick }) => {
  // Total items (sum all quantities)
  const totalQty = cart.reduce((sum, item) => sum + (item.quantity || 0), 0);

  return (
    <button
      className="
        fixed z-50
        bottom-6 right-6
        bg-white shadow-xl rounded-full
        flex items-center justify-center
        px-4 py-3
        border-2 border-blue-300
        hover:bg-blue-100
        transition
        outline-none
      "
      title="View Cart"
      onClick={onClick}
      type="button"
      style={{
        minWidth: "64px",
        minHeight: "64px",
      }}
    >
      <Badge
        badgeContent={totalQty}
        color="primary"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        showZero
        overlap="circular"
      >
        <ShoppingCartIcon style={{ fontSize: 36 }} className="text-blue-700" />
      </Badge>
    </button>
  );
};

export default CartBasket;
